'use client';
import { handleHeaderColorScheme } from '@lib/store/slices/ComponentsSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const ScrollHelperStandart = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(handleHeaderColorScheme(''));
    return function () {
      dispatch(handleHeaderColorScheme(''));
    };
  }, []);

  return null;
};

export default ScrollHelperStandart;
